module.exports = __webpack_public_path__ + "img/invoice-de-male-hh.cb7ec155.png";